import React, { useContext, useMemo, useState } from 'react';
import { getLocale, shallowEqual, useSelector } from 'umi';
import useStepOptions from "@/pages/dashboard/pages/funnel/_config/useStepOptions";
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLanguage } from '@home/utils/common';

const FunnelCardService = (props: any) => {
  const { style, className, api, dataKey = 'FunnelCard', formatterColumns, textEn = "Step", textCn = "步骤", showTab = false, defaultTabValue, children, ...resetProps } = props || {};
  const { filterVal } = useContext(FilterContext);
  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
  }), shallowEqual);
  const isEn = getLocale() === LANGUAGE_EN;
  const stepOptions = useStepOptions(filterVal);
  const [tabValue, setTabValue] = useState<any>(defaultTabValue || 'total');
  const [stepData, setStepData] = useState([]);

  const data = useMemo(() => ({
    gameCode,
    tabValue,
  }), [gameCode, tabValue]);

  const getSepIndex = (name: string) => {
    const index = stepOptions?.findIndex((item: any) => item?.value === name);
    return index ? index + 1 : 1;
  };

  const getSepItem = (name: string) => stepOptions?.find((item: any) => item?.value === name) || 0;
  const highestLostRate = stepData?.length === 0 ? "0" : stepData?.reduce((max: { lost_rate: string; }, obj: { lost_rate: string; }) => (parseFloat(obj?.lost_rate) > parseFloat(max?.lost_rate) ? obj : max), stepData?.[0])?.lost_rate;

  // 实际渲染的数据和下载的数据
  const formatData = (data: any) => {
    setStepData(data?.list || []);
    return data?.list || [];
  };

  const dataSource = useMemo(() => {
    const dataSource = stepData?.map((item: any) => {
      const itemObj = getSepItem(item?.stage_name);
      const stepIndex = getSepIndex(item?.stage_name);
      const dataObj = {
        ...item,
        ...itemObj,
        stepIndex,
        dataIndex: stepIndex - 1,
        key: stepIndex,
      };
      formatterColumns?.forEach((col: { key: string; formatRule: string; }) => {
        const { key, formatRule } = col;
        dataObj[key] = dataFormat({ value: item?.[key] || 0, formatRule });
      });
      dataObj.device_count_msg = `${dataObj?.device_count} (${dataObj?.conversion_rate})`;
      dataObj.textMsg = `${getLanguage(isEn, textEn, textCn)} ${stepIndex} ${itemObj?.text || ''}`;
      dataObj.highest_lost_rate = item?.lost_rate !== '' && parseFloat(item?.lost_rate) === parseFloat(highestLostRate);
      return dataObj;
    });
    return dataSource || [];
  }, [stepData, highestLostRate, formatterColumns, isEn]);

  return <div className={className} style={style}>
    <Service
      api={api}
      data={data}
      dataKey={dataKey}
      beforeRequest={(data) => {
        const { filterVal, gameCode, tabValue } = data;
        const { timeType, rangeTime, ...filters } = filterVal || {};
        const params: any = {
          game_code: gameCode,
          filters: formatFilterValues(filters),
        };
        if (showTab) {
          params.tab_type = tabValue;
        }
        if (timeType) {
          params.period = PERIODTIMEOBJ?.[timeType];
        }
        if (rangeTime) {
          params.start_time = rangeTime?.[0];
          params.end_time = rangeTime?.[1];
        }
        return params;
      }}
      formatData={formatData}
      trackData={['gameCode', 'tabValue']}
    >
      {React.Children.map(children, (child: any) => React.cloneElement(
        child,
        {
          filterVal,
          dataKey,
          tabValue,
          setTabValue,
          dataSource,
          ...resetProps,
        }
      ))}
    </Service>
  </div>;
};

export default FunnelCardService;